import { render, staticRenderFns } from "./AlarmControl.vue?vue&type=template&id=0c191e94&scoped=true&"
import script from "./AlarmControl.vue?vue&type=script&lang=js&"
export * from "./AlarmControl.vue?vue&type=script&lang=js&"
import style0 from "./AlarmControl.vue?vue&type=style&index=0&id=0c191e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c191e94",
  null
  
)

export default component.exports